import * as React from "react";
import { Toast, ToastMessage } from "primereact/toast";

const ToastContext = React.createContext<{
  showToast: (message: ToastMessage | ToastMessage[]) => void;
}>({
  showToast: () => {},
});

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const toastRef = React.useRef<Toast>(null);
  const showToast = React.useCallback(
    (message: ToastMessage | ToastMessage[]) => {
      toastRef.current?.show(message);
    },
    [],
  );
  // ToDo: if possible, style this so that the toast container is always on top z-index (over the dialog overlay)
  return (
    <ToastContext.Provider
      value={{
        showToast,
      }}
    >
      <Toast ref={toastRef} />
      {children}
    </ToastContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useShowToast = () => {
  const { showToast } = React.useContext(ToastContext);
  return showToast;
};
